import type { Html, Root } from "mdast";
import { visit } from "unist-util-visit";

import {
  parseReferenceAttributes,
  REFERENCE_ATTRS_PATTERN,
  REFERENCE_TAG,
} from "src/unifiedCopilot/chat/contextualEntityReferenceContent";

export const CONTEXTUAL_ENTITY_REFERENCE_ELEMENT_TAG =
  "contextual-entity-reference";

const REFERENCE_HTML_RE = new RegExp(
  `^\\s*<${REFERENCE_TAG}(${REFERENCE_ATTRS_PATTERN})\\s*/>\\s*$`,
);

export const remarkContextualEntityReference = (): ((tree: Root) => void) => {
  return (tree: Root): void => {
    visit(tree, "html", (node: Html) => {
      const match = node.value.match(REFERENCE_HTML_RE);
      if (!match) return;

      const rawAttrs = match[1] ?? "";
      const attrs = parseReferenceAttributes(rawAttrs);
      if (!attrs.id || !attrs.label) return;

      Object.assign(node, {
        type: "contextualEntityReference",
        data: {
          hName: CONTEXTUAL_ENTITY_REFERENCE_ELEMENT_TAG,
          hProperties: { "data-reference": rawAttrs },
        },
      });
    });
  };
};
